var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategory06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 30,
    viewBox: "0 0 33 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3645 24.3566C3.40558 22.0221 3.71092 18.5321 6.04546 16.5731L11.5064 11.9909L9.32982 9.39693L3.86889 13.9792C0.100846 17.141 -0.391207 22.7652 2.77056 26.5332C5.93232 30.3012 11.5565 30.7933 15.3246 27.6315L20.7855 23.0493L18.6089 20.4553L13.148 25.0376C10.8134 26.9965 7.32342 26.6912 5.3645 24.3566ZM12.1075 21.025L23.0294 11.8605L20.7382 9.13003L9.81639 18.2946L12.1075 21.025ZM17.5212 2.52354L12.0603 7.1058L14.2369 9.69974L19.6978 5.11748C22.0323 3.15856 25.5224 3.4639 27.4813 5.79845C29.4402 8.13299 29.1349 11.623 26.8003 13.5819L21.3394 18.1642L23.5159 20.7581L28.9769 16.1759C32.7449 13.0141 33.237 7.38991 30.0752 3.62187C26.9134 -0.146172 21.2893 -0.638225 17.5212 2.52354Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory06);
export default __webpack_public_path__ + "static/media/category-06.c44f885098950a0477b06a331732c924.svg";
export { ForwardRef as ReactComponent };